import {styled} from 'styled-components';

export const NotificationWrapper = styled.div`
  ${(props) => `
  max-width: 49.5rem;
  @media (max-width: ${props.theme.breakpoint_sm}) {
    max-width: 100%;
  }
  `}
`;
